// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"_1Gx6_MBrDwcNafEi2iLj3F","vertical":"_29TeoNAdGTDsZXL03M9Ulo"};